// extracted by mini-css-extract-plugin
export default {"inventory-productinfo":"inventory-productinfo","img-holder":"img-holder","no-img":"no-img","product-name":"product-name"};